<div class="wm-m-screenshotviewer-wrapper">
  <div class="info-tool-bar">
    @if (this.data.imageId && shouldShowScrollViewBtn) {
      <div>
        @if (fitToContainer) {
          <p-button (click)="goToScrollView()" styleClass="p-button-text" icon="true" pTooltip="Go back to scroll view"><fa-icon [icon]="faExpand" [fixedWidth]="true"></fa-icon></p-button>
        } @else {
          <p-button (click)="fitWholeImage()" styleClass="p-button-text" icon="true" pTooltip="Fit whole image"><fa-icon [icon]="faCompress" [fixedWidth]="true"></fa-icon></p-button>
        }
      </div>
    }
    <div>
      @if (this.data.imageId) {
        <p-button styleClass="p-button-text" (click)="editScreenshot($event);" icon="true" label="Edit"><fa-icon [icon]="faEdit" [fixedWidth]="true"></fa-icon></p-button>
      }
      <p-button styleClass="p-button-text" (click)="downloadScreenshot($event);" icon="true" label="Download"><fa-icon [icon]="faDownload" [fixedWidth]="true"></fa-icon></p-button>
      @if (data.offerContrastAnalysis) {
        <p-button styleClass="p-button-text" (click)="analyzeContrast($event);" [loading]="analyzingContrast"  icon="true" label="Analyze Contrast">@if (!analyzingContrast) {
          <fa-icon [icon]="faAdjust" [fixedWidth]="true"></fa-icon>
        }</p-button>
      }
    </div>
  </div>
  <div class="image-container">
    @if (childRecreateGuard) {
      @if (data.imageId) {
        <wm-image [downloadable]="true"
                  [displayMode]="'with_draw_canvas'"
                  [imageUrl]="data.imageUrl"
                  [imageId]="data.imageId"
                  [infoItems]="data.stateInfoItems || []"
                  [fillContainer]="fitToContainer">
        </wm-image>
      } @else {
        <wm-image [downloadable]="true"
                  [displayMode]="'without_draw_canvas'"
                  [imageUrl]="data.imageUrl"
                  [imageId]="data.imageId"
                  [infoItems]="data.stateInfoItems || []">
        </wm-image>
      }
    }
  </div>
</div>
